import { Component, OnInit, Input } from '@angular/core';
import { Paging } from '../../modals/paging.model';
import { Organization } from '../../modals/organization.model';
import { OrganizationService } from 'src/app/@core/services/organization/organization.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CauseService } from 'src/app/@core/services/cause/cause.service';
import {Location} from '@angular/common';
@Component({
  selector: 'app-organization',
  templateUrl: './organization.component.html',
  styleUrls: ['./organization.component.css']
})
export class OrganizationComponent implements OnInit {
  paging: Paging = new Paging();
  organizations:Array<Organization> = [];
  formIsLoading: boolean = false;
  errorMessage: string = '';
  organizationsData: any;
  @Input() redirectTo: number;
  notscrolly: boolean = true;
  notEmptyOrganization: boolean = true;
  pageSize: number;
  pageNumber: number;
  ID: number;
  isShowSelectBtn: boolean;
  constructor(private _causeservice: CauseService,
    private route: ActivatedRoute,
    private router: Router,
    private _location: Location,
    private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.route.params
    .subscribe(
      (params: Params) => {
        this.ID = +params['id'];

      }
    );
    this.pageSize = this.paging.page_size ;
    this.pageNumber = this.paging.page_number;
    this.organizationsData = 
    {
      'paging[page_size]': this.pageSize,
      'paging[page_number]': this.pageNumber,
       keyword: ''
    }
    // console.log(this.organizationsData['paging[page_number]'])
    this.listOrganizations();
    localStorage.getItem("from") && localStorage.getItem("from") === "auth" ? this.isShowSelectBtn = true : this.isShowSelectBtn = false
   
  }

  listOrganizations() {
    
   console.log("list organization");
    this.formIsLoading = true;
    this._causeservice.getAllCause().subscribe(
      res => {
        let organizations; 
          let data: any = res;
          // console.log(data);
          for (let i = 0; i < data.data.length; i++) {
            if(data.data[i].id === this.ID){
               organizations = data.data[i].organizations;
            }
          }


       this.spinner.hide();
 
       if (organizations.length === 0 ) {
         this.notEmptyOrganization =  false;
       }
       // add newly fetched posts to the existing post
       this.organizations = this.organizations.concat(organizations);
 
       this.notscrolly = true;
          this.formIsLoading = false;
      },
      err => {
        // console.log(err.error.error);
        let error = err.error.error
        this.errorMessage = error.error
        this.formIsLoading = false;
      }
  )
  }
  redirectBack() {
    this._location.back();
    // console.log(this.redirectTo);
    // if (this.redirectTo === 1) {
    //   this.router.navigate(['auth/sign-up']);

    // } else if(this.redirectTo === 2) {
    //   this.router.navigate(['settings']);
    // }
  }
  RedirectToMinMax() {
    this.router.navigate(['/auth/set-min-donation']);
  }
  onScroll() {
    // console.log('scrolled');
    if (this.notscrolly && this.notEmptyOrganization) {
     // this.spinner.show();
      //this.notscrolly = false;
      //this.loadNextOrganizations();
   }
  }
  loadNextOrganizations() {
    this.organizationsData['paging[page_number]']++;
    this.listOrganizations();
  }
  searchOrganization() {
    this.organizationsData['paging[page_number]'] = this.paging.page_number;
    this.organizations = [];
    this.notEmptyOrganization = true;
    this.notscrolly=true;
    this.listOrganizations();
  }
  

}
